export default __webpack_public_path__ + "static/media/ennovate_5.f19f7c71.jpg";